import { OrderSkuDetails } from "../../store/slices/CheckoutSlice";
import {
  DetailsType,
  OrderExtensionProps,
  OrderExtensionRelationType,
  SkuDetailsExistingOrderType,
} from "./type";
import NumericInput from "../../components/NumericInput/NumericInput";
import {
  MAX_QUANTITY,
  MAX_DURATION_MONTHS,
  MAX_DURATION_WEEKS,
} from "../../Constant";
import { isEmpty, validateCostInterval } from "../../utils/Validator";
import { MotifTooltip } from "@ey-xd/motif-react";
import { isSkuFixedOrOneTimeCost } from "../../utils/common";

export const getCostInterval = (costInterval: string) => {
  if (costInterval == "month") {
    return "Per month";
  }
  if (costInterval == "onetime") {
    return "One time";
  }
  if (costInterval == "week") {
    return "Per week";
  }
  if (costInterval == "autotransact") {
    return "Auto Transact";
  }
};
export const getDurationType = (costInterval: string) => {
  if (costInterval == "month") {
    return "months";
  }
  if (costInterval == "onetime") {
    return "One time";
  }
  if (costInterval == "week") {
    return "weeks";
  }
};
const handleDurationChange = (
  skuId: string,
  duration: string,
  skuListViewData: SkuDetailsExistingOrderType[],
  setSkuListViewData: (value: any) => void,
  parentSkuId: string | null = null,
  SetOrderExtenstionListState: React.Dispatch<
    React.SetStateAction<OrderExtensionProps | null>
  >,
  orderExtenstionListState: OrderExtensionProps | null | undefined,
  OrderSkuId: number,
) => {
  let updatedSkuListViewData = skuListViewData;
  if (parentSkuId !== null && parentSkuId !== undefined) {
    updatedSkuListViewData = skuListViewData.map(
      (sku: SkuDetailsExistingOrderType) => {
        if (sku.SkuId === parentSkuId) {
          const updatedSkuRelation = sku.SkuRelation.map((relation: any) => {
            const maxDuration =
              relation.CostIntervalCd === "month"
                ? MAX_DURATION_MONTHS
                : relation.CostIntervalCd === "week"
                  ? MAX_DURATION_WEEKS
                  : MAX_QUANTITY;
            if (
              relation.SkuId === skuId &&
              relation.OrderSkuId === OrderSkuId
            ) {
              return {
                ...relation,
                OrderSkuIntervals: Number(duration),
                DurationError:
                  duration == ""
                    ? "Required"
                    : Number(duration) > maxDuration
                      ? `Max value is ${maxDuration}`
                      : "",
              };
            }
            return relation;
          });
          return { ...sku, SkuRelation: updatedSkuRelation };
        }
        return sku;
      },
    );
    setSkuListViewData(updatedSkuListViewData);
    SetOrderExtenstionListState((prevState: any) => {
      if (!prevState) return null;
      return {
        ...prevState,
        Details: prevState.Details.map((detail: any) => {
          return {
            ...detail,
            SkuDetails: detail.SkuDetails.map((sku: any) => {
              if (!sku?.SkuId) {
                return sku; // Skip if SkuId is not present
              }
              return {
                ...sku,
                SkuRelation: sku.SkuRelation.map((skuRelation: any) => {
                  const maxDuration =
                    skuRelation.CostIntervalCd === "month"
                      ? MAX_DURATION_MONTHS
                      : skuRelation.CostIntervalCd === "week"
                        ? MAX_DURATION_WEEKS
                        : MAX_QUANTITY;
                  if (
                    skuRelation?.SkuId === skuId &&
                    sku.SkuId === parentSkuId &&
                    skuRelation.OrderSkuId === OrderSkuId
                  ) {
                    return {
                      ...skuRelation,
                      OrderSkuIntervals: Number(duration),
                      DurationError:
                        duration == ""
                          ? "Required"
                          : Number(duration) > maxDuration
                            ? `Max value is ${maxDuration}`
                            : "",
                    };
                  }
                  return skuRelation;
                }),
              };
            }),
          };
        }),
      };
    });
  } else {
    updatedSkuListViewData = skuListViewData.map(
      (sku: SkuDetailsExistingOrderType) => {
        if (sku.SkuId === skuId && sku.OrderSkuId === OrderSkuId) {
          const maxDuration =
            sku.CostIntervalCd === "month"
              ? MAX_DURATION_MONTHS
              : sku.CostIntervalCd === "week"
                ? MAX_DURATION_WEEKS
                : MAX_QUANTITY;
          return {
            ...sku,
            OrderSkuIntervals: Number(duration),
            DurationError:
              duration == ""
                ? "Required"
                : Number(duration) > maxDuration
                  ? `Max value is ${maxDuration}`
                  : "",
          };
        }
        return sku;
      },
    );
    setSkuListViewData(updatedSkuListViewData);
    const updateCheckListData = { ...orderExtenstionListState };
    const updateCheckListDataNew = updateCheckListData?.Details?.map(
      (detail: any) => {
        if (
          detail.SkuDetails.some(
            (sku: any) => sku.SkuId === skuId && sku.OrderSkuId === OrderSkuId,
          )
        ) {
          return {
            ...detail,
            SkuDetails: detail.SkuDetails.map((sku: any) => {
              const maxDuration =
                sku.CostIntervalCd === "month"
                  ? MAX_DURATION_MONTHS
                  : sku.CostIntervalCd === "week"
                    ? MAX_DURATION_WEEKS
                    : MAX_QUANTITY;
              if (sku.SkuId === skuId && sku.OrderSkuId === OrderSkuId) {
                return {
                  ...sku,
                  OrderSkuIntervals: Number(duration),
                  DurationError:
                    duration == ""
                      ? "Required"
                      : Number(duration) > maxDuration
                        ? `Max value is ${maxDuration}`
                        : "",
                };
              }
              return sku;
            }),
          };
        } else {
          return detail;
        }
      },
    );
    SetOrderExtenstionListState((prevState: any) => {
      if (!prevState) return null;
      return {
        ...prevState,
        Details: updateCheckListDataNew,
      };
    });
  }

  SetOrderExtenstionListState((previewData: OrderExtensionProps | null) => {
    previewData?.Details?.every(
      (productDetails) =>
        productDetails?.SkuDetails?.every(
          (sku: SkuDetailsExistingOrderType) => {
            if (sku.SkuId === skuId && sku.OrderSkuId === OrderSkuId)
              return true;
            const isValidDuration = sku.SkuRelation.length
              ? sku.SkuRelation?.every((relation) =>
                  validateCostInterval(
                    relation.CostIntervalCd,
                    relation.OrderSkuIntervals as number,
                    relation.CostIntervalMin,
                  ),
                )
              : true;
            if (!isValidDuration) return false;
            return validateCostInterval(
              sku.CostIntervalCd,
              sku.OrderSkuIntervals,
              sku.CostIntervalMin,
            );
          },
        ) ?? false,
    ) || false;
    return previewData;
  });

  // if any one product have error disable button
};

export const getSkuListFromOrderExtension = (
  orderExtensionData: OrderExtensionProps | null,
) => {
  if (!orderExtensionData || !orderExtensionData.Details) {
    return [];
  }
};

export const handleQuantityChange = (
  skuId: string,
  quantity: string,
  skuListViewData: SkuDetailsExistingOrderType[],
  setSkuListViewData: (value: any) => void,
) => {
  const updatedSkuListViewData = skuListViewData.map(
    (sku: SkuDetailsExistingOrderType) => {
      if (sku.SkuId === skuId) {
        return {
          ...sku,
          OrderQuantity: quantity,
          QuantityError:
            quantity === ""
              ? "Required"
              : Number(quantity) <= 0
                ? "Min 1"
                : Number(quantity) > MAX_QUANTITY
                  ? `Max value is ${MAX_QUANTITY}`
                  : "",
        };
      }
      return sku;
    },
  );
  setSkuListViewData(updatedSkuListViewData);
};
export const getDuration = (
  sku: SkuDetailsExistingOrderType,
  skuListViewData: SkuDetailsExistingOrderType[],
  setSkuListViewData: (value: any) => void,
  parentSkuId: string | null = null,
  SetOrderExtenstionListState: React.Dispatch<
    React.SetStateAction<OrderExtensionProps | null>
  >,
  orderExtenstionListState: OrderExtensionProps | null | undefined,
) => {
  if (sku.CostIntervalCd == "onetime") {
    return "Not Applicable";
  } else {
    return (
      <NumericInput
        id={"" + sku.OrderSkuId}
        value={sku.OrderSkuIntervals}
        min={0}
        max={
          sku.CostIntervalCd === "month"
            ? MAX_DURATION_MONTHS
            : sku.CostIntervalCd === "week"
              ? MAX_DURATION_WEEKS
              : undefined
        }
        placeholder={sku.CostIntervalCd == "month" ? "Months" : "Weeks"}
        onChange={(val) => {
          handleDurationChange(
            sku.SkuId,
            val,
            skuListViewData,
            setSkuListViewData,
            parentSkuId,
            SetOrderExtenstionListState,
            orderExtenstionListState,
            sku.OrderSkuId,
          );
        }}
        label="duration"
      />
    );
  }
};

export const getRelationDuration = (
  skuRelation: SkuDetailsExistingOrderType,
  skuListViewData: SkuDetailsExistingOrderType[],
  setSkuListViewData: (value: any) => void,
  parentSkuId: string | null = null,
  SetOrderExtenstionListState: React.Dispatch<
    React.SetStateAction<OrderExtensionProps | null>
  >,
  orderExtenstionListState: OrderExtensionProps | null | undefined,
) => {
  if (skuRelation.CostIntervalCd == "onetime") {
    return "Not Applicable";
  } else {
    return (
      <NumericInput
        id={skuRelation.SkuId}
        value={skuRelation.OrderSkuIntervals}
        min={0}
        max={
          skuRelation.CostIntervalCd === "month"
            ? MAX_DURATION_MONTHS
            : skuRelation.CostIntervalCd === "week"
              ? MAX_DURATION_WEEKS
              : undefined
        }
        placeholder={skuRelation.CostIntervalCd == "month" ? "Months" : "Weeks"}
        onChange={(val) =>
          handleDurationChange(
            skuRelation.SkuId,
            val,
            skuListViewData,
            setSkuListViewData,
            parentSkuId,
            SetOrderExtenstionListState,
            orderExtenstionListState,
            skuRelation.OrderSkuId,
          )
        }
        label="duration"
      />
    );
  }
};
export const calculateTotalCost = (sku: SkuDetailsExistingOrderType) => {
  if (!sku) {
    return "--";
  }
  const quantity = sku.OrderSkuQunatity || sku.OrderSkuQuantity || 0;
  const cost = sku.CostMetricCost || 0;
  const duration = sku.OrderSkuIntervals || 0;

  const totalCost = quantity * cost * duration;
  if (totalCost === 0) {
    return 0;
  }
  return totalCost.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const calculatePeriodTotalCost = (sku: SkuDetailsExistingOrderType) => {
  if (!sku) {
    return "--";
  }
  const quantity = sku.OrderSkuQunatity || sku.OrderSkuQuantity || 0;
  const cost = sku.CostMetricCost || 0;

  const totalCost = quantity * cost;
  if (totalCost === 0) {
    return "--";
  }
  return totalCost.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const calculateRelationTotalCost = (
  sku: SkuDetailsExistingOrderType,
  skuRelation: SkuDetailsExistingOrderType,
) => {
  if (sku.OrderSkuIntervals === 0) {
    return "--";
  }
  const quantity = skuRelation.OrderSkuQunatity || 0;
  const cost = skuRelation.CostMetricCost || 0;
  const duration = skuRelation.OrderSkuIntervals || 0;
  const totalCost = quantity * cost * duration;
  if (totalCost === 0) {
    return "--";
  }

  return totalCost.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};
export const getOrderSkuDetails = (
  skuListViewData: SkuDetailsExistingOrderType[],
): OrderSkuDetails[] => {
  if (!skuListViewData || skuListViewData.length === 0) {
    return [];
  }

  const orderSkus: OrderSkuDetails[] = [];

  skuListViewData.forEach((sku: SkuDetailsExistingOrderType) => {
    const orderSku: OrderSkuDetails = {
      SkuId: sku.SkuId,

      Quantity: sku.OrderSkuQunatity || 0,

      Intervals: sku.OrderSkuIntervals || 0,
    };

    orderSkus.push(orderSku);

    if (sku.SkuRelation && sku.SkuRelation.length > 0) {
      sku.SkuRelation.forEach((relation: any) => {
        const orderSkuRelation: OrderSkuDetails = {
          SkuId: relation.SkuId,

          ParentSkuId: sku.SkuId,

          Quantity: relation.OrderSkuQuantity || 0,

          Intervals: relation.OrderSkuIntervals || 0,
        };

        orderSkus.push(orderSkuRelation);
      });
    }
  });

  return orderSkus;
};

export function getSkuListFromOrderBundle(
  orderExtenstionListState: OrderExtensionProps | null,
) {
  const OrderSkuList: {
    SkuId: any;
    ParentSkuId: any;
    Quantity: any;
    Intervals: any;
  }[] = [];
  orderExtenstionListState?.Details?.forEach((orderDataRow: any) => {
    orderDataRow?.SkuDetails?.forEach((sku: any) => {
      if (!sku?.SkuId) {
        return;
      }
      const skuId = sku.SkuId;
      const parentSkuId = sku.ParentSkuId || "";
      const quantity = sku.OrderQuantity || 0;
      const duration = sku.OrderSkuIntervals || 0;
      OrderSkuList.push({
        SkuId: skuId,
        ParentSkuId: parentSkuId,
        Quantity: quantity,
        Intervals: duration,
      });
      if (sku?.SkuRelation?.length > 0) {
        sku?.SkuRelation?.forEach((relation: any) => {
          const OrderSkuRelation = {
            SkuId: relation.SkuId,
            ParentSkuId: sku.SkuId,
            Quantity: Number(relation.OrderQuantity),
            Intervals: Number(relation.OrderSkuIntervals),
          };
          OrderSkuList.push(OrderSkuRelation);
        });
      }
    });
  });
  return OrderSkuList;
}

const validatingEngagementCode = (
  engagementCode: string,
  billingType: string,
) => {
  if (!engagementCode || engagementCode.length === 0) {
    return false;
  }
  const first_char = engagementCode.substring(0, 1).toLowerCase();
  if (billingType === "skubill_engagement" && first_char !== "e") {
    return false;
  } else if (first_char !== "i" && first_char !== "e") {
    return false;
  } else {
    return true;
  }
};

export function getSkuListFromOrderBundleWithEngagement(
  orderExtenstionListState: OrderExtensionProps | null,
  engagementCode: string,
  engagementCodeException?: string,
) {
  const OrderSkuErrorList: {
    SkuId: any;
    SkuName: string;
    ParentSkuId: any;
    Quantity: any;
    Intervals: any;
    EngagementCode?: string;
    isError?: boolean;
  }[] = [];
  const OrderSkuList: {
    SkuId: any;
    ParentSkuId: any;
    EngagementId?: string;
  }[] = [];
  let hasError = false;
  orderExtenstionListState?.Details?.forEach((orderDataRow: any) => {
    orderDataRow?.SkuDetails?.forEach((sku: any) => {
      if (!sku?.SkuId) {
        return;
      }
      const skuId = sku.SkuId;
      const parentSkuId = sku.ParentSkuId || "";
      const quantity = sku.OrderQuantity || 0;
      const duration = sku.OrderSkuIntervals || 0;
      if (
        !validatingEngagementCode(engagementCode, sku.BillingTypeCd) &&
        isEmpty(engagementCodeException)
      ) {
        hasError = true;
        OrderSkuErrorList.push({
          SkuId: skuId,
          SkuName: sku.Name,
          ParentSkuId: parentSkuId,
          Quantity: quantity,
          Intervals: duration,
          EngagementCode: engagementCode || "",
          isError:
            engagementCode &&
            validatingEngagementCode(engagementCode, sku.BillingTypeCd)
              ? false
              : true,
        });
      } else if (validatingEngagementCode(engagementCode, sku.BillingTypeCd)) {
        OrderSkuList.push({
          SkuId: skuId,
          ParentSkuId: parentSkuId,
          EngagementId: engagementCode || "",
        });
      } else if (
        !isEmpty(engagementCodeException) &&
        !validatingEngagementCode(engagementCode, sku.BillingTypeCd)
      ) {
        OrderSkuList.push({
          SkuId: skuId,
          ParentSkuId: parentSkuId,
          EngagementId: engagementCodeException || "",
        });
      } else {
        OrderSkuList.push({
          SkuId: skuId,
          ParentSkuId: parentSkuId,
          EngagementId: engagementCode || "",
        });
      }

      if (sku?.SkuRelation?.length > 0) {
        sku?.SkuRelation?.forEach((relation: any) => {
          if (
            !validatingEngagementCode(engagementCode, relation.BillingTypeCd) &&
            isEmpty(engagementCodeException)
          ) {
            hasError = true;
            OrderSkuErrorList.push({
              SkuId: relation.SkuId,
              SkuName: relation.Name,
              ParentSkuId: sku.SkuId,
              Quantity: Number(relation.OrderQuantity),
              Intervals: Number(relation.OrderSkuIntervals),
              EngagementCode: engagementCode || "",
              isError:
                engagementCode &&
                validatingEngagementCode(engagementCode, relation.BillingTypeCd)
                  ? false
                  : true,
            });
          } else if (
            validatingEngagementCode(engagementCode, relation.BillingTypeCd)
          ) {
            OrderSkuList.push({
              SkuId: relation.SkuId,
              ParentSkuId: sku.SkuId,
              EngagementId: engagementCode || "",
            });
          } else if (
            !isEmpty(engagementCodeException) &&
            !validatingEngagementCode(engagementCode, relation.BillingTypeCd)
          ) {
            OrderSkuList.push({
              SkuId: relation.SkuId,
              ParentSkuId: sku.SkuId,
              EngagementId: engagementCodeException || "",
            });
          } else {
            OrderSkuList.push({
              SkuId: relation.SkuId,
              ParentSkuId: sku.SkuId,
              EngagementId: engagementCode || "",
            });
          }
        });
      }
    });
  });
  return hasError
    ? {
        hasError: hasError,
        OrderSkuList: OrderSkuList,
        OrderSkuErrorList: OrderSkuErrorList,
      }
    : {
        hasError: hasError,
        OrderSkuList: OrderSkuList,
      };
}

export function getSkuListFromOrderBundleWithEngagementEstimate(
  orderExtenstionListState: OrderExtensionProps | null,
  engagementCode: string,
  engagementCodeException?: string,
) {
  const OrderSkuList: {
    SkuId: any;
    ParentSkuId: any;
    EngagementId?: string | null;
  }[] = [];

  orderExtenstionListState?.Details?.forEach((orderDataRow: any) => {
    orderDataRow?.SkuDetails?.forEach((sku: any) => {
      if (!sku?.SkuId) {
        return;
      }
      const skuId = sku.SkuId;
      const parentSkuId = sku.ParentSkuId || "";
      if (
        !validatingEngagementCode(engagementCode, sku.BillingTypeCd) &&
        isEmpty(engagementCodeException)
      ) {
        OrderSkuList.push({
          SkuId: skuId,
          ParentSkuId: parentSkuId,
          EngagementId: "",
        });
      } else if (validatingEngagementCode(engagementCode, sku.BillingTypeCd)) {
        OrderSkuList.push({
          SkuId: skuId,
          ParentSkuId: parentSkuId,
          EngagementId: engagementCode || "",
        });
      } else if (
        !isEmpty(engagementCodeException) &&
        !validatingEngagementCode(engagementCode, sku.BillingTypeCd)
      ) {
        OrderSkuList.push({
          SkuId: skuId,
          ParentSkuId: parentSkuId,
          EngagementId: engagementCodeException || "",
        });
      } else {
        OrderSkuList.push({
          SkuId: skuId,
          ParentSkuId: parentSkuId,
          EngagementId: engagementCode || "",
        });
      }

      if (sku?.SkuRelation?.length > 0) {
        sku?.SkuRelation?.forEach((relation: any) => {
          if (
            !validatingEngagementCode(engagementCode, relation.BillingTypeCd) &&
            isEmpty(engagementCodeException)
          ) {
            OrderSkuList.push({
              SkuId: relation.SkuId,
              ParentSkuId: sku.SkuId,
              EngagementId: "",
            });
          } else if (
            validatingEngagementCode(engagementCode, relation.BillingTypeCd)
          ) {
            OrderSkuList.push({
              SkuId: relation.SkuId,
              ParentSkuId: sku.SkuId,
              EngagementId: engagementCode || "",
            });
          } else if (
            !isEmpty(engagementCodeException) &&
            !validatingEngagementCode(engagementCode, relation.BillingTypeCd)
          ) {
            OrderSkuList.push({
              SkuId: relation.SkuId,
              ParentSkuId: sku.SkuId,
              EngagementId: engagementCodeException || "",
            });
          } else {
            OrderSkuList.push({
              SkuId: relation.SkuId,
              ParentSkuId: sku.SkuId,
              EngagementId: engagementCode || "",
            });
          }
        });
      }
    });
  });
  return {
    hasError: false,
    OrderSkuList: OrderSkuList,
  };
}

type ErrorPayload = {
  SkuId: string;
  EngagementId: string;
  EngagementErrorData: any;
  EngagementErrorMessage: string;
};

export function getEngagementErrorFromResponse(
  orderExtenstionListState: OrderExtensionProps | null,
  errorPayload: ErrorPayload[],
  engagementCode: string,
  engagementCodeException: string,
  showEngagementException: boolean,
) {
  const OrderSkuErrorList: {
    SkuId: any;
    SkuName: string;
    ParentSkuId: any;
    Quantity: any;
    Intervals: any;
    EngagementCode?: string;
    isError?: boolean;
  }[] = [];

  const OrderSkuErrorListException: {
    SkuId: any;
    SkuName: string;
    ParentSkuId: any;
    Quantity: any;
    Intervals: any;
    EngagementCode?: string;
    isError?: boolean;
  }[] = [];

  orderExtenstionListState?.Details?.forEach((orderDataRow: any) => {
    orderDataRow?.SkuDetails?.forEach((sku: any) => {
      const errorInSku = errorPayload.find(
        (payload) =>
          payload.SkuId === sku.SkuId &&
          engagementCode === payload?.EngagementId,
      );
      const errorInSkuException = errorPayload.find(
        (payload) =>
          payload.SkuId === sku.SkuId &&
          engagementCodeException === payload?.EngagementId,
      );

      const skuId = sku.SkuId;
      const parentSkuId = sku.ParentSkuId || "";
      const quantity = sku.OrderQuantity || 0;
      const duration = sku.OrderSkuIntervals || 0;
      const inputString = engagementCode.toUpperCase().trim();
      const firstChar = inputString.substring(0, 1);
      if (
        errorInSku === undefined ||
        firstChar === "E" ||
        !showEngagementException
      )
        OrderSkuErrorList.push({
          SkuId: skuId,
          SkuName: sku.Name,
          ParentSkuId: parentSkuId,
          Quantity: quantity,
          Intervals: duration,
          //@ts-ignore
          EngagementCode:
            firstChar === "E"
              ? engagementCode
              : errorInSkuException?.EngagementId,
          isError: true,
        });
      else
        OrderSkuErrorListException.push({
          SkuId: skuId,
          SkuName: sku.Name,
          ParentSkuId: parentSkuId,
          Quantity: quantity,
          Intervals: duration,
          EngagementCode: errorInSku?.EngagementId,
          isError: true,
        });
      if (sku?.SkuRelation?.length > 0) {
        sku?.SkuRelation?.forEach((relation: any) => {
          const errorInSku = errorPayload.find(
            (payload) =>
              payload.SkuId === sku.SkuId &&
              engagementCode === payload.EngagementId,
          );
          const errorInSkuException = errorPayload.find(
            (payload) =>
              payload.SkuId === sku.SkuId &&
              engagementCodeException === payload.EngagementId,
          );
          const skuId = relation.SkuId;
          const parentSkuId = sku.SkuId || "";
          const quantity = relation.OrderQuantity || 0;
          const duration = relation.OrderSkuIntervals || 0;
          const OrderSkuRelation =
            errorInSku === undefined || firstChar === "E"
              ? {
                  SkuId: skuId,
                  SkuName: relation.Name,
                  ParentSkuId: parentSkuId,
                  Quantity: quantity,
                  Intervals: duration,
                  //@ts-ignore
                  EngagementCode:
                    firstChar === "E"
                      ? engagementCode
                      : errorInSkuException?.EngagementId,
                  isError: true,
                }
              : {
                  SkuId: skuId,
                  SkuName: relation.Name,
                  ParentSkuId: parentSkuId,
                  Quantity: quantity,
                  Intervals: duration,
                  EngagementCode: errorInSku?.EngagementId,
                  isError: true,
                };
          if (errorInSku === undefined)
            OrderSkuErrorListException.push(OrderSkuRelation);
          else OrderSkuErrorList.push(OrderSkuRelation);
        });
      }
    });
  });
  return {
    hasError: true,
    OrderSkuList: OrderSkuErrorList,
    OrderSkuListException: OrderSkuErrorListException,
  };
}

export const getTotalOrderAmountRow = (sku: SkuDetailsExistingOrderType) => {
  if (!sku || sku === null) {
    return 0;
  }
  let totalAmount = 0;
  const quantity = sku.OrderSkuQunatity || sku.OrderSkuQuantity || 0;
  const cost = sku.CostMetricCost || 0;
  const duration = sku.OrderSkuIntervals || 0;
  totalAmount += cost * quantity * duration;
  if (sku.SkuRelation && sku.SkuRelation.length > 0) {
    sku.SkuRelation.forEach((relation: OrderExtensionRelationType) => {
      const quantity = relation.OrderSkuQunatity || 0;
      const cost = relation.CostMetricCost || 0;
      const duration = relation.OrderSkuIntervals || 0;
      totalAmount += cost * quantity * duration;
    });
  }
  return totalAmount;
};

export const getTotalOrderAmountRowVariable = (
  sku: SkuDetailsExistingOrderType,
) => {
  if (!sku || sku === null) {
    return 0;
  }
  let totalAmount = 0;
  if (!isSkuFixedOrOneTimeCost(sku.CostMetricCd, sku.CostIntervalCd)) {
    const quantity = sku.OrderSkuQunatity || sku.OrderSkuQuantity || 0;
    const cost = sku.CostMetricCost || 0;
    const duration = sku.OrderSkuIntervals || 0;
    totalAmount += cost * quantity * duration;
  }
  if (sku.SkuRelation && sku.SkuRelation.length > 0) {
    sku.SkuRelation.forEach((relation: OrderExtensionRelationType) => {
      if (
        !isSkuFixedOrOneTimeCost(relation.CostMetricCd, relation.CostIntervalCd)
      ) {
        const quantity = relation.OrderSkuQunatity || 0;
        const cost = relation.CostMetricCost || 0;
        const duration = relation.OrderSkuIntervals || 0;
        totalAmount += cost * quantity * duration;
      }
    });
  }
  return totalAmount;
};

export const getTotalOrderAmount = (orderList: DetailsType[]) => {
  let totalAmount = 0;
  if (!orderList || orderList.length === 0) {
    return totalAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  } else {
    orderList.forEach((order) => {
      order.SkuDetails.forEach((sku: SkuDetailsExistingOrderType) => {
        totalAmount += getTotalOrderAmountRow(sku);
      });
    });
    return totalAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }
};

export const getTotalOrderAmountVariable = (orderList: DetailsType[]) => {
  let totalAmount = 0;
  if (!orderList || orderList.length === 0) {
    return totalAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  } else {
    orderList.forEach((order) => {
      order.SkuDetails.forEach((sku: SkuDetailsExistingOrderType) => {
        if (isSkuFixedOrOneTimeCost(sku.CostMetricCd, sku.CostIntervalCd)) {
          if (sku.SkuRelation && sku.SkuRelation.length > 0) {
            sku.SkuRelation.forEach((relation: OrderExtensionRelationType) => {
              if (
                isSkuFixedOrOneTimeCost(
                  relation.CostMetricCd,
                  relation.CostIntervalCd,
                )
              ) {
              } else {
                const quantity =
                  relation.OrderSkuQunatity || relation.OrderSkuQunatity || 0;
                const cost = relation.CostMetricCost || 0;
                const duration = relation.OrderSkuIntervals || 0;
                totalAmount += cost * quantity * duration;
              }
            });
          }
        } else {
          totalAmount += getTotalOrderAmountRowVariable(sku);
        }
      });
    });
    return totalAmount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }
};
export const getUniqueEngagementCode = (
  orderExtenstionListState: OrderExtensionProps | null,
) => {
  const engArray: { uniqueEngagementName: string; uniqueEngagement: string }[] =
    [];
  if (orderExtenstionListState === null) {
    return [];
  } else {
    orderExtenstionListState?.Details?.forEach((orderDataRow: any) => {
      orderDataRow?.SkuDetails?.forEach((sku: any) => {
        let engCodeFound = undefined;
        if (engArray.length > 0 && sku?.EngagementId !== null) {
          engCodeFound = engArray.find(
            (element) => element === sku?.EngagementId,
          );
        }
        if (engCodeFound === undefined && sku?.EngagementId !== null) {
          engArray.push({
            uniqueEngagementName: sku?.EngagementName,
            uniqueEngagement: sku?.EngagementId,
          });
        }
        if (sku?.SkuRelation?.length > 0) {
          sku?.SkuRelation?.forEach((relation: any) => {
            const engCodeFound =
              engArray.length === 0
                ? undefined
                : engArray.find(
                    (element) => element === relation?.EngagementId,
                  );
            if (engCodeFound === undefined && relation?.EngagementId !== null) {
              engArray.push({
                uniqueEngagementName: relation?.EngagementName,
                uniqueEngagement: relation?.EngagementId,
              });
            }
          });
        }
      });
    });
  }
  const sortedEngArray = engArray.sort((a, b) =>
    b.uniqueEngagement.localeCompare(a.uniqueEngagement),
  );
  return sortedEngArray;
};

export const getEngagementCodeExceptionCount = (
  orderExtenstionListState: OrderExtensionProps,
) => {
  let count = 0;
  if (orderExtenstionListState === null) {
    return [];
  } else {
    orderExtenstionListState?.Details?.forEach((orderDataRow: any) => {
      orderDataRow?.SkuDetails?.forEach(
        (sku: { EngagementId: string; SkuRelation: any[] }) => {
          const inputString = sku.EngagementId.toUpperCase().trim();
          const firstChar = inputString.substring(0, 1);
          if (firstChar === "E") {
            count = count + 1;
          }
          if (sku?.SkuRelation?.length > 0) {
            sku?.SkuRelation?.forEach((relation: any) => {
              const inputString = relation.EngagementId.toUpperCase().trim();
              const firstChar = inputString.substring(0, 1);
              if (firstChar === "E") {
                count = count + 1;
              }
            });
          }
        },
      );
    });
  }
  return count;
};

export function renderEngagementName(engagementName: string) {
  if (engagementName.length > 46) {
    return (
      <>
        <MotifTooltip
          contentClassName="tooltip-content"
          allowClick
          allowHover
          flip
          id="tooltip-engagementName"
          offset={[0, 8]}
          placement="auto"
          trigger={engagementName.slice(0, 45) + "..."}
          variant="default"
        >
          {engagementName}
        </MotifTooltip>
      </>
    );
  } else {
    return engagementName;
  }
}

export const getRetiredSkuList = (
  checkoutListData: OrderExtensionProps | null,
) => {
  let skuErrorList: string[] = [];
  if (checkoutListData === null) return skuErrorList;
  checkoutListData?.Details?.forEach((Detail) => {
    Detail?.SkuDetails?.forEach((sku) => {
      if (sku.SkuStatusCd === "sku_retired") {
        skuErrorList.push(sku.SkuId);
      }
      if (sku?.SkuRelation?.length > 0) {
        sku?.SkuRelation?.forEach((relation: any) => {
          if (relation.StatusCd === "sku_retired") {
            skuErrorList.push(relation.SkuId);
          }
        });
      }
    });
  });
  return skuErrorList;
};
